/*
 * Centralised runtime configuration for the API/WS layer.
 *
 * `VITE_API_BASE` is the single knob. In dev it typically points straight at
 * the backend (`http://localhost:8000`); in the nginx-served production image
 * it defaults to a relative `/api` that the reverse proxy forwards (keeping the
 * SPA origin-agnostic). The WS base is derived from it by swapping the scheme.
 */

function trimTrailingSlash(url: string): string {
  return url.replace(/\/+$/, "");
}

/** REST base, e.g. `http://localhost:8000` or `/api`. No trailing slash. */
export const API_BASE: string = trimTrailingSlash(
  import.meta.env.VITE_API_BASE ?? "http://localhost:8000",
);

/**
 * WebSocket base derived from `API_BASE`. Absolute http(s) → ws(s); a relative
 * base (`/api`) is resolved against the current page origin so the WS shares
 * the SPA's host/proxy.
 */
export function wsBaseUrl(): string {
  let httpBase = API_BASE;
  if (httpBase.startsWith("/")) {
    httpBase = `${window.location.origin}${httpBase}`;
  }
  return httpBase.replace(/^http/i, "ws");
}

/** Build the full WS URL for a run's status stream. */
export function runStatusWsUrl(runId: string): string {
  return `${wsBaseUrl()}/ws/runs/${encodeURIComponent(runId)}`;
}
